module.exports = __webpack_public_path__ + "img/icon-arrow-matrix-overview.90f304f2.svg";